<section [class.mobile]="deviceService.isMobile()" [class.tablet]="deviceService.isTablet()" class="teacher-card">
  <div class="top-block">
    <div class="avatar-block">
      <ng-template [ngIf]="!isMe">
        <ng-container *ngTemplateOutlet="tools_wrap"></ng-container>
      </ng-template>
      <div class="avatar-wrap">
        <on-ui-cover [cover]="avatar" data-test="userpic"></on-ui-cover>
        <div [class.offline]="!statusOnline" [class.online]="statusOnline" class="status"></div>
      </div>
    </div>

    <div class="info-block">
      <ng-container *ngTemplateOutlet="top_info"></ng-container>
      <ng-container *ngTemplateOutlet="country_info"></ng-container>
      <ng-container *ngTemplateOutlet="teaching_info_list"></ng-container>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="about"></ng-container>
  <ng-container *ngTemplateOutlet="statistics_block"></ng-container>

  <ng-content></ng-content>

  <div class="footer-block">
    <div class="price-wrap" [attr.data-test]="'card_tutors_price'">
      <ng-template [ngIf]="stats && stats.min_price_tier">
        <span class="price-tier-label">{{ 'library.user-mini-card.from' | customLocale }}</span>
        <span class="price-tier">{{ getFormattedAmount() | async }}</span>
        <span class="price-tier-label">{{ 'library.user-mini-card.price' | customLocale }}</span>
      </ng-template>
    </div>
    <div class="stats-actions">
      <ng-template [ngIf]="!isExpandPanel">
        <on-ui-button
          (onclick)="onToggleExpandPanel()"
          class="primary outline stats-action-item"
          iconPosition="after"
          label="collections.actions.details">
          <app-icon height="10" width="10" file="chevron" icon="down"></app-icon>
        </on-ui-button>
      </ng-template>

      <ng-template [ngIf]="teacher.visit_info?.can_sign_up" [ngIfElse]="cantSignupRef">
        <on-ui-button
          (onclick)="openCheckoutModal()"
          [attr.data-test]="'sign-up-button'"
          class="secondary"
          label="teacher-card.actions.sign-up">
        </on-ui-button>
      </ng-template>
      <ng-template #cantSignupRef>
        <on-ui-button class="status" label="teacher-card.actions.no-available-hours"> </on-ui-button>
      </ng-template>
    </div>
  </div>
</section>

<ng-template #tools_wrap>
  <div class="tools-wrap">
    <div class="tools-box">
      <div class="menu-wrap">
        <on-ui-card-menu>
          <a *ngIf="teacher.purl" [href]="teacher.purl" class="menu-item warn">[⚠️] Panel</a>
          <ng-template [ngIf]="!isMe">
            <div (click)="onOpenComplainForm()" class="menu-item">
              {{ 'user-profile.menu-complain' | customLocale }}
            </div>
          </ng-template>
        </on-ui-card-menu>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #top_info>
  <div class="top-info">
    <div class="name-wrap">
      <a [attr.title]="fullName" [routerLink]="profileUrl" class="teacher-name">{{ fullName }}</a>
      <app-icon height="16" width="18" file="status" icon="teacher-verify"></app-icon>
    </div>
  </div>
</ng-template>

<ng-template #country_info>
  <div class="country-info">
    <ng-template [ngIf]="country">
      <div class="country-and-flag">
        <div class="flag-wrap">
          <img *ngIf="country?.flag_url" [alt]="country?.title_native" [src]="country?.flag_url" class="flag" />
        </div>

        <span class="country">({{ country?.title_native }})</span>
      </div>
    </ng-template>

    <div class="speak-wrap">
      <span class="speak-label">{{ 'teacher-card.speak-on' | customLocale }}</span>
      <span class="speak-value" *ngFor="let language of speakLanguages; let last = last"
        >{{ language.title }}<span *ngIf="!last">,</span></span
      >
    </div>
  </div>
</ng-template>

<ng-template #about>
  <p class="about"><span (click)="onOpenAbout()" [innerHTML]="profile?.about"></span></p>
</ng-template>

<ng-template #statistics_block>
  <div class="statistics-block">
    <div class="stats-list">
      <div *ngFor="let stat of statsList; let last = last; trackBy: trackByFn" class="stats-item">
        <span class="stats-label">{{ stat.title | customLocale }}</span>
        <span class="stats-label value">{{ stat.value }}</span>
        <span *ngIf="!last" class="point"></span>
      </div>
      <div class="stats-item">
        <span class="point" *ngIf="stats.reviews_rating"></span>
        <app-rating [stats]="stats" [user]="teacher" [label]="true"> </app-rating>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #teaching_info_list>
  <div *ngIf="teachingSubjectsList.length" class="teaching-list-mobile">
    <div class="list">
      <div *ngFor="let teach of teachingSubjectsList; let last = last; trackBy: trackByFn" class="teaching-item">
        <span>{{ teach?.title }}</span
        ><span *ngIf="!last" class="point"></span>
      </div>
    </div>
  </div>
</ng-template>

<app-mobile-modal (closed)="onToggleExpandPanel()" *ngIf="isExpandPanel" [footerVisible]="true">
  <app-mobile-modal-title>
    {{ fullName }}
  </app-mobile-modal-title>
  <app-mobile-modal-body>
    <section [class.tablet]="deviceService.isTablet()" class="mobile-modal-wrap">
      <app-user-profile-page
        [isModal]="true"
        [selectedSubjectId]="teachingSubject.subject_id"
        [userName]="profileUrl[1]"></app-user-profile-page>
    </section>
  </app-mobile-modal-body>
  <app-mobile-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-teacher-booking-surface-block [teacher]="teacher"></app-teacher-booking-surface-block>
    </ng-template>
  </app-mobile-modal-ad>
</app-mobile-modal>

<app-mobile-modal *ngIf="openComplainForm" (closed)="onCloseComplainForm()" [titleVisible]="false">
  <app-mobile-modal-body>
    <app-complaint-form (cancel)="onCloseComplainForm()" [type]="'user'"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
